import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, DialogContent, DialogTitle, Dialog } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MaterialTable from 'material-table';
import NotificationView from './NotificationView';
import { getHisttoryAction } from '../../../actions/notificationActions';

function NotificationHistory({ title, handleClose, historyId, getHisttoryData, historyData }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState();
  useEffect(() => {
    getHisttoryData(historyId);
  }, []);

  return (
    <Fragment>
      <DialogTitle className="pop_head" id="form-dialog-title">
        {`Notification History`}
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={'pop_body'}>
        <div className="tbl_wrap no_sch mt20 no_round">
          <MaterialTable
            title="Version History"
            columns={[
              {
                title: 'Version',
                field: 'version',
                render: rowData => (
                  <button
                    type="button"
                    onClick={() => {
                      setOpen(true);
                      setData(rowData);
                    }}>
                    {rowData.version}
                  </button>
                ),
              },
              {
                title: 'lastChgDate',
                field: 'lastChgDate',
                render: rowData => (
                  <button
                    type="button"
                    onClick={() => {
                      setOpen(true);
                      setData(rowData);
                    }}>
                    {rowData.lastChgDate.replace(/T/gi, ' ')}
                  </button>
                ),
              },
            ]}
            data={historyData}
            options={{
              search: false,
              paging: true,
            }}
          />
        </div>
        <div className={'btn_set_wrap alC'}>
          <Button variant="contained" className={'btn_color2'} onClick={handleClose}>
            Close
          </Button>
        </div>
      </DialogContent>
      <Dialog open={open} className={'pop_wrap'}>
        <NotificationView data={data} title={title} handleClose={() => setOpen(false)} />
      </Dialog>
    </Fragment>
  );
}

NotificationHistory.propTypes = {
  title: PropTypes.string.isRequired,
  historyData: PropTypes.array.isRequired,
  historyId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  getHisttoryData: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  historyData: state.homeApp.notificationsHistory,
});

const mapDispatchToProps = dispatch => ({
  getHisttoryData: id => dispatch(getHisttoryAction(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationHistory);
